module.exports = __webpack_public_path__ + "img/08_noff_open_L1.d54a6cfc.svg";